import { ActionType } from 'typesafe-actions';

import ResearchersPage, { Researcher } from '@interfaces/researchers-page';
import ResearcherTab from '@interfaces/researchers-tab';

import * as types from './types';
import * as actions from './actions';

export type ResearchersAction = ActionType<typeof actions>;

export interface ResearchersState {
    readonly list: ResearchersPage;
    readonly one: Partial<Researcher>;
    readonly selectedThemeSlug?: string;
    readonly selectedTabIndex: number;
    readonly tabs: ResearcherTab[];
    readonly isLoading: boolean;
    readonly error?: string | boolean;
}

const initialState: ResearchersState = {
    list: { rows: [], meta: {} },
    one: {},
    selectedThemeSlug: undefined,
    selectedTabIndex: 0,
    tabs: [],
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line */
function reducer(state: ResearchersState = initialState, action: ResearchersAction): ResearchersState {
    switch (action.type) {
        case types.FETCH_RESEARCHERS_PAGE:
            return fetchResearchersPage(state, action);

        case types.FETCH_RESEARCHERS_PAGE_SUCCESS:
            return fetchResearchersPageSuccess(state, action);

        case types.FETCH_RESEARCHERS_PAGE_ERROR:
            return fetchResearchersPageError(state, action);

        case types.FETCH_RESEARCHER:
            return fetchResearcher(state);

        case types.FETCH_RESEARCHER_SUCCESS:
            return fetchResearcherSuccess(state, action);

        case types.FETCH_RESEARCHER_ERROR:
            return fetchResearcherError(state, action);

        case types.SET_SELECTED_THEME_SLUG:
            return setSelectedThemeSlug(state, action);

        case types.SET_SELECTED_TAB_INDEX:
            return setSelectedTabIndex(state, action);

        case types.SET_RESEARCHER_TABS:
            return setResearcherTabs(state, action);

        default:
            return state;
    }
}

function fetchResearchersPage(state: ResearchersState, action: any) {
    const { page = 1 } = action.payload;

    // Если загружается первая страница, обнуляем существующий список
    // что-бы показать content placeholders
    const list = {
        ...state.list,
        rows: page === 1 ? [] : state.list.rows
    };

    return {
        ...state,
        list,
        isLoading: true,
        error: false
    };
}

function fetchResearchersPageSuccess(state: ResearchersState, action: any) {
    const { meta, rows: actionRows } = action.payload;
    const rows = meta.pageNumber === 1 ? actionRows : [...state.list.rows, ...actionRows];

    return {
        ...state,
        list: { meta, rows },
        isLoading: false,
        error: false
    };
}

function fetchResearchersPageError(state: ResearchersState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchResearcher(state: ResearchersState) {
    return {
        ...state,
        one: {},
        isLoading: true,
        error: false
    };
}

function fetchResearcherSuccess(state: ResearchersState, action: any) {
    return {
        ...state,
        one: action.payload,
        isLoading: false,
        error: false
    };
}

function fetchResearcherError(state: ResearchersState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function setSelectedThemeSlug(state: ResearchersState, action: any) {
    return {
        ...state,
        selectedThemeSlug: action.payload
    };
}

function setSelectedTabIndex(state: ResearchersState, action: any) {
    return {
        ...state,
        selectedTabIndex: action.payload
    };
}

function setResearcherTabs(state: ResearchersState, action: any) {
    return {
        ...state,
        tabs: action.payload
    };
}

export default reducer;
